import React, { useContext } from 'react';

import FormData from './Form.context';
import Label from './Label.form';
import ErrorMsg from './ErrorMsg.form';

const Url = props => {
	const {
		required = false,
		name = 'url',
	} = props;

	const { register } = useContext(FormData);

	const isUrl = url => {
		const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
			'(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
			'(\\#[-a-z\\d_]*)?$','i'); // fragment locator

		return url.length === 0 || !!pattern.test(url) || 'Not a valid URL';
	};

	const reg = {
		validate: isUrl,
	};

	if (required)
		reg.required = 'Required';

	return (
		<div className='form-group-old'>
			<Label {...props} />

			<input
				name={name}
				ref={register(reg)}
			/>

			<ErrorMsg {...props} />
		</div>
	);
};

export default Url;
